import formatTableJson from '@/config/tableComponentParams.js'
import { functionTypeTag } from '@/config/tag'
import i18n from '@/locales/index'
export default formatTableJson([
  {
    filed: 'type',
    label: i18n.t('Product.productFuncType'),
    type: 'tag',
    colorList: functionTypeTag,
    formatFn: function(_, row) {
      return row.typeName
    }
  },
  {
    filed: 'name',
    label: i18n.t('Product.productFuncName'),
    width: '200px',
    showOverflowTooltip: true
  },
  {
    filed: 'identifier',
    label: i18n.t('Product.identifier'),
    width: '180px',
    showOverflowTooltip: true
  },
  {
    filed: 'dataType',
    label: i18n.t('Product.dataType')
  },
  {
    filed: 'dataDefinition',
    label: i18n.t('Product.dataDefinition'),
    width: '220px',
    showOverflowTooltip: true
  }
])
